import { getAuthClient } from '@/plugins/auth-client'
import { Store, ActionTree, ActionContext } from 'vuex'
import type { User } from '@/model/user/schema'
import { AuthState } from './state'
import { RootState } from '../state'

export interface Actions<S, R> extends ActionTree<S, R> {
  updateUser(this: Store<R>, context: ActionContext<S, R>, user: User): void
}

export default {
  async updateUser(_context, user) {
    getAuthClient()?.user(user)
  }
} as Actions<AuthState, RootState>
